//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Command, type ModelDocumentSelection } from "ckeditor5";

export default class ResizeFigureCommand extends Command {
  refresh() {
    const editor = this.editor;
    const element = this._getSelectedModelWidget(editor.model.document.selection);

    this.isEnabled = !!element;
    if (!element || !element.hasAttribute("maxWidth")) {
      this.value = null;
    } else {
      this.value = {
        maxWidth: element.getAttribute("maxWidth"),
      };
    }
  }

  execute(maxWidth: number | string) {
    const editor = this.editor;
    const model = editor.model;
    const figureElement = this._getSelectedModelWidget(model.document.selection);

    if (figureElement) {
      model.change((writer) => {
        writer.setAttribute("maxWidth", maxWidth, figureElement);
      });
    }
  }

  private _getSelectedModelWidget(selection: ModelDocumentSelection) {
    const selectedElement = selection.getSelectedElement();
    if (selectedElement && selectedElement.is("element", "media")) {
      return selectedElement;
    }
    return null;
  }
}
